import { render, staticRenderFns } from "./ScrollSticky.vue?vue&type=template&id=1b446606&"
import script from "./ScrollSticky.vue?vue&type=script&lang=js&"
export * from "./ScrollSticky.vue?vue&type=script&lang=js&"
import style0 from "./ScrollSticky.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports